const theme = {
  regularFont: "NohemiRegular",
  lightFont: "NohemiLight",
  darkBg1: "#010323",
  darkBg2: "#0a0409",
  textColor: "#FFFFFF",
  // Accent system - magenta brand color, applied with restraint.
  accent: "#E180F7",
  accentSoft: "rgba(225, 128, 247, 0.12)",
  accentBorder: "rgba(225, 128, 247, 0.25)",
  // Cool-warm near-black panel for cards/sections.
  panel: "#1a0e1f",
  hairline: "rgba(255, 255, 255, 0.08)",
  textMuted: "rgba(255, 255, 255, 0.65)",
  // The brand gradient - reserve for a single emphasized word, not whole headings.
  brandGradient:
    "linear-gradient(94.67deg, #C65DC6 10%, #E180F7 40%, #7F58B7 75%, #5DBAF2 100%)",
};

export default theme;
